<picture class="responsive-image">
	@for (format of modernFormats; track format) {
		<source
			[attr.srcset]="buildSrcset(format)"
			[attr.sizes]="sizesAttr()"
			[attr.type]="'image/' + format"
		/>
	}
	<img
		[src]="fallbackSrc()"
		class="responsive-image__img"
		[attr.srcset]="buildSrcset('jpg')"
		[attr.sizes]="sizesAttr()"
		[attr.width]="imageWidth()"
		[attr.height]="imageHeight()"
		[attr.alt]="imageAlt()"
		[attr.itemprop]="itemProp() ? itemProp() : null"
		[attr.loading]="isLazyLoaded() ? 'lazy' : 'eager'"
		[attr.decoding]="isLazyLoaded() ? 'async' : 'sync'"
		[attr.fetchpriority]="isLazyLoaded() ? null : 'high'"
	/>
</picture>
